'use client';

import React, { useEffect, useState } from 'react';
import Calculator from './Calculator/FinanceCalculatorCalculator';
import CarList from './CarList/FinanceCalculatorCarList';
import Steps from './Steps/FinanceCalculatorSteps';

const MainSection = ({ data }) => {
  const [mode, setMode] = useState('CAR');
  const [selectedCar, setSelectedCar] = useState('');
  const [selectedCarPrice, setSelectedCarPrice] = useState(0);

  // 从 URL 参数中获取来源信息
  const getUrlParams = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('from');
  };

  const from = getUrlParams();

  useEffect(() => {
    if (from === 'car-configurator') {
      // 从 localStorage 获取汽车配置信息
      const carConfig = JSON.parse(localStorage.getItem('carConfigurationStore') || '{}');

      if (carConfig.carType && data.length > 0) {
        const matchingCar = data.find(
          (car) => car.fields?.title?.value?.toLowerCase() === carConfig.carType.toLowerCase()
        );

        if (matchingCar) {
          const capID = matchingCar.fields?.capID?.value || '';
          const numericCarPrice = parseInt(carConfig.carPrice?.replace(/[^0-9]/g, '') || '0', 10);

          setSelectedCar(capID);
          setSelectedCarPrice(numericCarPrice);
          setMode('CALCULATOR');
        }
      }
    }
  }, [from, data]);

  useEffect(() => {
    if (from === 'car-configurator') return;

    if (selectedCar && data.length > 0) {
      const matchingCar = data.find((car) => car.fields?.capID?.value === selectedCar);
      setSelectedCarPrice(matchingCar?.fields?.cashPrice?.value || 0);
    }
  }, [selectedCar, data, from]);

  const handleSelectCar = (car) => {
    const capID = car.fields?.capID?.value || '';
    setSelectedCar(capID);
    setMode('CALCULATOR');
  };

  const handleStepChange = (stepId) => {
    switch (stepId) {
      case 1:
        setMode('CAR');
        break;
      case 2:
        if (selectedCar) {
          setMode('CALCULATOR');
        }
        break;
      default:
        setMode('CAR');
    }
  };

  const modeToStep = (currentMode) => {
    switch (currentMode) {
      case 'CAR':
        return 1;
      case 'CALCULATOR':
        return 2;
      default:
        return 1;
    }
  };

  return (
    <div className="container">
      <Steps activeStep={modeToStep(mode)} onStepChange={handleStepChange} />
      {mode === 'CAR' && <CarList data={data} selectCar={handleSelectCar} />}
      {mode === 'CALCULATOR' && <Calculator capID={selectedCar} cashPrice={selectedCarPrice} />}
    </div>
  );
};

export default MainSection;
